import { GetterTree } from 'vuex';
import { State } from '@/store/modules/synthetics/commonState/commonState.store';

const getters: GetterTree<State, State> = {
  getAllSyntheticServices: state => {
    return state.services;
  },
  getCurrentSyntheticServices: state => {
    return state.currentService;
  },
  getCurrentSMPage: state => {
    return state.currentSMPage;
  },
  getIsFormOpened: state => {
    return state.isFormOpened;
  }
};

export default getters;
